// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3AXJz","footer__copyright":"Footer_footer__copyright__2G0dT"};